import { NextRequest, NextResponse } from "next/server";
import fs from "fs";
import path from "path";

// Ensure the logs directory exists
const LOGS_DIR = path.join(process.cwd(), "logs");
if (!fs.existsSync(LOGS_DIR)) {
  fs.mkdirSync(LOGS_DIR, { recursive: true });
}

export async function POST(req: NextRequest) {
  try {
    const body = await req.json();
    const { message, level = "info", data, timestamp } = body;

    // Create a filename based on the current date, e.g., app-2023-10-27.log
    const dateStr = new Date().toISOString().split("T")[0];
    const logFilePath = path.join(LOGS_DIR, `app-${dateStr}.log`);

    // Format the log entry
    let dataStr = "";
    if (data) {
      if (typeof data === "object") {
        dataStr = ` - ${JSON.stringify(data)}`;
      } else {
        dataStr = ` - ${String(data)}`;
      }
    }

    const logEntry = `[${timestamp || new Date().toISOString()}] [${level.toUpperCase()}] ${message}${dataStr}\n`;

    // Append to file
    fs.appendFileSync(logFilePath, logEntry, "utf8");

    return NextResponse.json({ success: true });
  } catch (error) {
    console.error("Failed to write log to file:", error);
    return NextResponse.json(
      { success: false, error: "Failed to write log" },
      { status: 500 }
    );
  }
}
